<template>
  <div>
    <!-- Custom cursor disabled -->
  </div>
</template>

<script>
export default {
  name: 'CustomCursor',
  data() {
    return {
      mouseX: 0,
      mouseY: 0,
      dotX: 0,
      dotY: 0,
      ringX: 0,
      ringY: 0,
      isHovering: false,
      isClicking: false,
      animationFrameId: null
    };
  },
  mounted() {
    // Custom cursor functionality disabled
    // Uncomment the code below to re-enable custom cursor
    
    /*
    // Add custom-cursor-area class to body
    document.body.classList.add('custom-cursor-area');
    
    // Setup event listeners
    document.addEventListener('mousemove', this.onMouseMove);
    document.addEventListener('mousedown', this.onMouseDown);
    document.addEventListener('mouseup', this.onMouseUp);
    
    // Setup hover detection for interactive elements
    this.setupHoverDetection();
    
    // Start animation loop
    this.animateCursor();
    */
  },
  beforeUnmount() {
    // Clean up event listeners
    document.body.classList.remove('custom-cursor-area');
    document.removeEventListener('mousemove', this.onMouseMove);
    document.removeEventListener('mousedown', this.onMouseDown);
    document.removeEventListener('mouseup', this.onMouseUp);
    
    // Stop animation loop
    if (this.animationFrameId) {
      cancelAnimationFrame(this.animationFrameId);
    }
  },
  methods: {
    onMouseMove(e) {
      this.mouseX = e.clientX;
      this.mouseY = e.clientY;
    },
    onMouseDown() {
      this.isClicking = true;
      document.body.classList.add('cursor-click');
    },
    onMouseUp() {
      this.isClicking = false;
      document.body.classList.remove('cursor-click');
    },
    setupHoverDetection() {
      // Add hover detection for interactive elements
      const interactiveElements = document.querySelectorAll('button, a, .btn, .level-card, .rating-circle, .industry-chip, .rating-star, .rating-dot, .geo-rating-dot, .brand-item');
      
      interactiveElements.forEach(el => {
        el.addEventListener('mouseenter', () => {
          this.isHovering = true;
          document.body.classList.add('cursor-hover');
        });
        
        el.addEventListener('mouseleave', () => {
          this.isHovering = false;
          document.body.classList.remove('cursor-hover');
        });
      });
      
      // We need to re-run this when new elements are added to the DOM
      // This could be improved with a more robust mutation observer approach
      this.$nextTick(() => {
        setTimeout(() => {
          this.setupHoverDetection();
        }, 1000);
      });
    },
    animateCursor() {
      // Calculate smooth movement using lerp (linear interpolation)
      const lerp = (start, end, factor) => start + (end - start) * factor;
      
      // Smooth factor - lower for more lag, higher for more responsiveness
      const smoothFactor = 0.2;
      
      // Update dot and ring positions with smooth movement
      this.dotX = lerp(this.dotX, this.mouseX, smoothFactor);
      this.dotY = lerp(this.dotY, this.mouseY, smoothFactor);
      
      // Ring follows with a slight delay
      this.ringX = lerp(this.ringX-3, this.mouseX, smoothFactor * 0.8);
      this.ringY = lerp(this.ringY-2.55, this.mouseY, smoothFactor * 0.8);
      
      // Apply the positions
      if (this.$refs.dot) {
        this.$refs.dot.style.transform = `translate(${this.dotX}px, ${this.dotY}px)`;
      }
      
      if (this.$refs.ring) {
        this.$refs.ring.style.transform = `translate(${this.ringX}px, ${this.ringY}px)`;
      }
      
      // Continue animation loop
      this.animationFrameId = requestAnimationFrame(this.animateCursor);
    }
  }
};
</script>

<style scoped>
/* The actual cursor styles are in assets/styles/cursor.css 
   to be globally available throughout the app */
</style> 